<script>
export default {
    data() {
        return {
            searchModal: false
        }
    },
    methods: {
        showSearchModal () {
            this.searchModal = true
        },

        closeSearchModal() {
            this.searchModal = false
        },
    }
}
</script>